import { render, staticRenderFns } from "./goods-vip.vue?vue&type=template&id=54f1e765&scoped=true"
import script from "./goods-vip.vue?vue&type=script&lang=js"
export * from "./goods-vip.vue?vue&type=script&lang=js"
import style0 from "./goods-vip.vue?vue&type=style&index=0&id=54f1e765&prod&lang=scss"
import style1 from "./goods-vip.vue?vue&type=style&index=1&id=54f1e765&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f1e765",
  null
  
)

export default component.exports